import api from "../api"
import { auth, diagnostic, doctor, patient } from "../api_endpoints"


export const checkByAadhaar=async(data)=>{
    const aadhaar_id=data

    try {
        const response=await api.post(auth.checkUserByAdhaar,{aadhaar_id})
        return response.response
    } catch (error) {
        throw error.response
    }
}

export const sendOtp=async(data)=>{
    const mobile=data

    try {
        const response=await api.post(auth.sendOtp,{mobile,requester:"Doctor"})
        return response
    } catch (error) {
        throw error
    }
}

export const loginHospital=async(data)=>{
    const {mobile,aadhaar_id,device_token,otp}=data

    try {
        const response=await api.post(auth.loginDoctor,{mobile,aadhaar_id,device_token,otp})
        return response
    } catch (error) {
        throw error
    }
}

export const createHospital=async(data)=>{
    const {first_name,last_name,aadhaar_id,email,gender,profile_image,primary_number,dob,license_number,hospital_name,address}=data
    const formData = new FormData()
    formData.append("first_name", first_name);
    formData.append("last_name", last_name);
    formData.append("aadhaar_id", aadhaar_id);
    formData.append("email", email);
    formData.append("gender", gender);
    formData.append("profile_image", profile_image);
    formData.append("primary_number", primary_number);
    formData.append("dob", dob);
    formData.append("license_number", license_number);
    formData.append("hospital_name", hospital_name);
    formData.append("address", address);

    try {
        const response=await api.post(auth.createDoctor,formData,{
             headers: {
          "Content-Type": "multipart/form-data",
        },
        })
        return response
    } catch (error) {
        throw error
    }
}

export const patientMapCheck=async(data)=>{
    let token=data.token
    try {
        const response=await api.post(patient.checkMap,{aadhaar_id:data.aadhaar_id},{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}

export const getPatientMapped=async(token)=>{
    
    try {
        const response=await api.get(patient.getmappedPatient,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}

export const sendOtpPatientMapping=async(data)=>{
    let token=data.token
   
    
    try {
        const response=await api.post(patient.patientMappingOtpSend,
            {patient_user_id:data.id,
            relationship_type:"primary doctor"
        },{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}

export const verifyOtpPatientMapping=async(data)=>{
    let token=data.token
   
    
    try {
        const response=await api.post(patient.createMappingVerify,
            {patient_user_id:data.id,
            relationship_type:"primary hospital",
            otp:data.otp
        },{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}



export const getMappedRequestFromdoctors=async(token)=>{
    
    try {
        console.log(token);
        
        const response=await api.get(doctor.getAllRequestFromDoctor,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}


export const getAlldoctors=async(token)=>{
    
    try {
        console.log(token);
        
        const response=await api.get(doctor.getAllDoctors,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}


export const requestDoctormapping=async(token,data)=>{
    
    try {
        console.log(token);
        
        const response=await api.post(doctor.requestToDoctorMapping,data,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}


export const getDoctorProfile=async(token)=>{
    
    try {
        console.log(token);
        
        const response=await api.get(auth.getProfile,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}


export const getAlldiagnostic=async(token)=>{
    
    try {
        console.log(token);
        
        const response=await api.get(diagnostic.getallDiagnostics,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}

export const requestDiagnosticmapping=async(token,data)=>{
    
    try {
        console.log(token);
        
        const response=await api.post(diagnostic.requestToDiagnosticMapping,data,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}

export const actionRequestDoctor=async(id,data,token)=>{
    try {
        console.log(token);
        
        const response=await api.post(`${doctor.actionRequestOfDoctors}${id}/action`,data,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}


export const getOwnRequestToDoc=async(token)=>{
    
    try {
        console.log(token);
        
        const response=await api.get(doctor.ownRequestToDoctor,{
           
    headers: {
      Authorization: `Bearer ${token}`,   

        }})
       
        return response
        
    } catch (error) {
      throw error
        
    }
}

